import styled from 'styled-components';
import { repeatShadow } from '../styles/utils';
import { vh } from '../styles/utils';

export const MenuContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgb(78, 131, 190);
  display: flex;
  flex-direction: column;
  gap: ${vh(4)};
  align-items: center;
  justify-content: center;
  padding-bottom: ${vh(5)};
`;

const titleShadow = repeatShadow('#555', 25);

export const MenuTitle = styled.h1`
  text-transform: uppercase;
  font-size: ${vh(14)};
  font-weight: bold;
  margin-top: 0;
  margin-bottom: ${vh(8)};
  text-shadow: ${titleShadow};
`;

export const ModeButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${vh(3)};
  margin-left: ${vh(8)};
`;

export const ModeButtonsInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${vh(1.5)};
`;

type MenuButtonProps = {
  outline?: boolean;
};

export const MenuButton = styled.button<MenuButtonProps>`
  background-color: ${(props) => props.outline ? 'transparent' : 'rgb(124, 188, 130)'};
  border: ${(props) => props.outline ? `solid ${vh(0.4)} #eee` : 'none'};
  border-radius: 999rem;
  color: inherit;
  font-size: ${vh(6)};
  width: ${vh(40)};
  height: ${vh(11)};
  padding: ${vh(1.5)} 0 ${vh(2)};
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  
  :active,
  :focus {
    background-color: ${(props) => props.outline ? '#33333333' : 'rgb(99, 152, 104)'};
  }

  :disabled {
    cursor: default;
    background-color: #999;
  }
`;

export const ModeInfoButton = styled.button`
  background-color: transparent;
  border: solid ${vh(0.4)} #eee;
  border-radius: 999rem;
  color: inherit;
  text-align: center;
  font-size: ${vh(6)};
  box-sizing: border-box;
  padding: 0;
  width: ${vh(11)};
  height: ${vh(11)};
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  
  :active,
  :focus {
    background-color: #33333333;
  }

  :disabled {
    cursor: default;
    background-color: #999;
    opacity: 0;
    pointer-events: none;
  }
`;

export const MenuScore = styled.h2`
  margin: 0;
  font-size: ${vh(4)};
  font-weight: normal;
`;

export const ModeInfo = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const ModeInfoInner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  width: ${vh(75)};
  height: ${vh(55)};
  margin-left: auto;
  margin-right: auto;
  margin-top: ${vh(10)};
  gap: ${vh(1)};
  background-color: rgb(60, 72, 133);
  z-index: 3;
  font-size: ${vh(4.5)};
  padding: ${vh(5)};
  border-radius: ${vh(2)};
  border: solid ${vh(0.2)} #333;
  
  p {
    margin: 0;
  }
  
  ${MenuButton} {
    position: absolute;
    bottom: ${vh(5)};
  }
`;

export const ModeInfoTitle = styled.h2`
  margin: 0;
  font-weight: normal;
  font-size: ${vh(8)};
  margin-bottom: ${vh(2)};
`;
